import { AttendanceSheetDisponivelDto } from '@/api.types';
import { formatarMesAnoLegivel, formatarYyyyMmMesExtensoOuIndefinido } from '@/shared/utils/datas';
import { Form } from 'react-bootstrap';

type Props = {
  opcoes: AttendanceSheetDisponivelDto[];
  /** Id da folha atualmente exibida (valor controlado do select). */
  folhaIdAtual: string | undefined;
  mesSelecionado: string;
  anoFolha?: number;
  mesFolha?: number;
  onTrocarFolha: (novaFolhaId: string) => void;
};

/**
 * Seletor de outra folha (estagiário com lista da API) ou rótulo estático mês/ano.
 */
export default function AttendanceSheetMonthSelector({
  opcoes,
  folhaIdAtual,
  mesSelecionado,
  anoFolha,
  mesFolha,
  onTrocarFolha,
}: Props) {
  const textoEstatico = formatarYyyyMmMesExtensoOuIndefinido(
    mesSelecionado ||
      (anoFolha != null && mesFolha != null ? `${anoFolha}-${String(mesFolha).padStart(2, '0')}` : ''),
  );

  if (opcoes.length > 0) {
    return (
      <Form.Group className="mb-0" controlId="seletor-mes-ano-folha">
        <Form.Label visuallyHidden>Mês e ano da folha</Form.Label>
        <Form.Select
          size="sm"
          aria-label="Mês e ano da folha"
          value={folhaIdAtual ?? ''}
          style={{ minWidth: '14rem' }}
          onChange={(e) => {
            const id = e.target.value;
            if (id && id !== folhaIdAtual) onTrocarFolha(id);
          }}
        >
          {opcoes.map((f) => (
            <option key={f.id} value={f.id}>
              {formatarMesAnoLegivel(f.ano, f.mes)}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
    );
  }

  return <span className="form-control btn-sm">{textoEstatico}</span>;
}
